module.exports = "<ng-container *ngIf=\"content | async as document\">\n    <!--<rows [rows$]=\"list.data\"></rows>-->\n    <ng-container [ngSwitch]=\"( document | meta ).obj_type\">\n        <marquee-document *ngSwitchCase=\"'Text Marquee'\" [item]=\"document\"></marquee-document>\n        <text-post *ngSwitchDefault [document]=\"document\"></text-post>\n    </ng-container>\n</ng-container>"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/containers/document-container/document-container.template.html
// module id = 870
// module chunks = 2